import { AlertTriangle, RefreshCw } from "lucide-react";

export default function ErrorState({ title = "Não foi possível carregar", message, onRetry, testid = "error-state" }) {
  return (
    <div data-testid={testid} className="al-card p-10 text-center max-w-xl mx-auto">
      <div className="w-12 h-12 rounded-full bg-[#FEE2E2] text-[#EF4444] flex items-center justify-center mx-auto mb-4">
        <AlertTriangle className="w-6 h-6" />
      </div>
      <p className="text-[15px] font-bold text-[#111827]">{title}</p>
      {message && (
        <p className="text-[12.5px] text-[#6B7280] mt-1.5 leading-relaxed">{message}</p>
      )}
      {onRetry && (
        <button
          data-testid={`${testid}-retry-btn`}
          onClick={onRetry}
          className="mt-5 inline-flex items-center gap-1.5 px-4 h-9 rounded-lg al-btn-primary text-[12.5px] font-medium"
        >
          <RefreshCw className="w-3.5 h-3.5" /> Tentar novamente
        </button>
      )}
    </div>
  );
}
